import { useContext } from 'react';
import { NavSizeContext } from '../components/common/Page';

const useNavSize = () => {
  const navRefs = useContext(NavSizeContext);
  return navRefs;
};

export default useNavSize;
